import {
  locationIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-ids/ids";
import {
  ReservedBucketCategorySchema,
  StorageLocationTypeSchema,
} from "@redotech/redo-model/wms/schema/storage-location";
import * as z from "zod";

export const createStorageLocations = {
  name: "createStorageLocations" as const,
  input: z.object({
    names: z.array(z.string().min(1)).min(1, "At least one name is required"),
    locationId: locationIdFormat.schema,
    type: StorageLocationTypeSchema,
    isSellable: z.boolean().optional(),
    reservedBucketCategory: ReservedBucketCategorySchema.optional(),
  }),
  output: z.object({
    storageLocationIds: z.array(storageLocationIdFormat.schema),
    errors: z.array(z.object({ name: z.string(), error: z.string() })),
  }),
};

export type CreateStorageLocationsInput = z.infer<
  typeof createStorageLocations.input
>;

export {
  PersistentLocationTypes,
  ReservedBucketCategorySchema,
  StorageLocationType,
} from "@redotech/redo-model/wms/schema/storage-location";
